import {
  FETCH_DISCUSSION_UNREADS_REQUEST,
  FETCH_DISCUSSION_UNREADS_SUCCESS,
  MARK_DISCUSSION_SEEN_SUCCESS,
  BOARD_UNREAD_UPDATED,
} from "./unreadTypes";

const initialState = {
  loading: false,
  data: [],
  globalTotal: 0,
};

export default function boardDiscussionUnreadReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DISCUSSION_UNREADS_REQUEST:
      return { ...state, loading: true };

    case FETCH_DISCUSSION_UNREADS_SUCCESS:
      return { loading: false, data: action.payload || [] };

    case MARK_DISCUSSION_SEEN_SUCCESS: {
      const { BoardID, level, TaskID, TaskMapID } = action.payload;
      return {
        ...state,
        data: state.data.map((board) => {
          if (String(board.BoardID) !== String(BoardID)) return board;
          if (level === "board") {
            const diff = board.general;
            return {
              ...board,
              general: 0,
              totalUnread: Math.max(0, board.totalUnread - diff),
            };
          }
          if (level === "task") {
            return {
              ...board,
              tasks: board.tasks.map((t) => {
                if (String(t.TaskID) !== String(TaskID)) return t;
                const diff = t.unread;
                return { ...t, unread: 0 };
              }),
              totalUnread: Math.max(
                0,
                board.totalUnread -
                  (board.tasks.find(
                    (t) => String(t.TaskID) === String(TaskID),
                  )?.unread || 0),
              ),
            };
          }
          if (level === "subtask") {
            return {
              ...board,
              tasks: board.tasks.map((t) => {
                if (String(t.TaskID) !== String(TaskID)) return t;
                const sub = t.subtasks.find(
                  (s) => String(s.TaskMapID) === String(TaskMapID),
                );
                const diff = sub?.unread || 0;
                return {
                  ...t,
                  subtasks: t.subtasks.map((s) =>
                    String(s.TaskMapID) === String(TaskMapID)
                      ? { ...s, unread: 0 }
                      : s,
                  ),
                };
              }),
              totalUnread: Math.max(
                0,
                board.totalUnread -
                  (board.tasks
                    .find((t) => String(t.TaskID) === String(TaskID))
                    ?.subtasks.find(
                      (s) => String(s.TaskMapID) === String(TaskMapID),
                    )?.unread || 0),
              ),
            };
          }
          return board;
        }),
      };
    }

    case BOARD_UNREAD_UPDATED: {
      const { BoardID, general, tasks, totalUnread, boardId, total } = action.payload;
      // Global push from socket — only has 'total' field
      if (total != null) {
        return { ...state, globalTotal: total };
      }
      // Per-board push — has full BoardID and breakdown
      if (BoardID) {
        return {
          ...state,
          data: state.data.map((board) => {
            if (String(board.BoardID) !== String(BoardID)) return board;
            return { ...board, general, tasks, totalUnread };
          }),
        };
      }
      return state;
    }

    default:
      return state;
  }
}
